import { DatesDictionary } from 'types/i18n';
import { format } from 'date-fns';
import { ru } from 'date-fns/locale';
import { capitalizeFirstLetter } from 'utils/stringUtils';

export const datesDictionaryRu: DatesDictionary = {
  monthOfYearDate(date) {
    const monthName = capitalizeFirstLetter(
      format(new Date(date), 'LLLL', { locale: ru })
    );

    const yearText = format(new Date(date), 'yy', { locale: ru });

    return `${monthName} '${yearText}`;
  },
  calendarDate(date) {
    const dateText = format(date, 'dd.MM.yyyy');

    return dateText;
  },
  calendarDateWithTime(date) {
    const dateText = format(date, 'dd.MM.yyyy');
    const timeText = format(date, 'HH:mm');

    return `${dateText} в ${timeText}`;
  },
  fd1(date) {
    const formattedDate = format(date, 'd LLLL yyyy', { locale: ru });

    return formattedDate.replace('.', '');
  },
  fd14(date) {
    const formattedDate = format(date, 'd MMM', { locale: ru });

    return formattedDate.replace('.', '');
  },
};
